import { ActionTypes } from "../constants/action_types";

const initialValue = null;

export const projectOverviewReducer = (state = initialValue, { type, payload }) => {
    switch (type) {
        case ActionTypes.PROJECT_OVERVIEW:
            return payload
        default:
            return state;
    }
}